module.exports = __webpack_public_path__ + "58811d28.png";